<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form>
        <div class="form-group">
          <label class="control-label"
            >{{ $t('eschool.name') }} <span class="text-danger">*</span>
          </label>
          <input
            v-model="model.event_name"
            type="text"
            class="form-control kh-font"
            :class="{ 'is-invalid': errors.has('event_name') }"
          />
          <div class="invalid-feedback" v-if="errors.has('event_name')">
            {{ errors.first('event_name') }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-12">
            <div class="form-group">
              <label class="control-label">
                {{ $t('eschool.startDate') }} <span class="text-danger">*</span>
              </label>
              <ts-date-picker-inputs v-model="model.event_start_date" />
              <div style="color:#cc4946;margin:4px 0 0">
                {{ errors.first('event_start_date') }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-12">
            <div class="form-group">
              <label class="control-label">
                {{ $t('eschool.endDate') }} <span class="text-danger">*</span>
              </label>
              <ts-date-picker-inputs v-model="model.event_end_date" />
              <div style="color:#cc4946;margin:4px 0 0">
                {{ errors.first('event_end_date') }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label"> {{ $t('eschool.criteria') }} </label>
          <textarea
            v-model="model.event_criteria"
            rows="3"
            class="form-control"
            :class="{ 'is-invalid': errors.has('event_criteria') }"
          ></textarea>
          <div class="invalid-feedback" v-if="errors.has('event_criteria')">
            {{ errors.first('event_criteria') }}
          </div>
        </div>
        <div class="form-group" v-if="!editing">
          <h2 class="ts-capitalize ts-font-semibold ts-underline mb-2">
            {{ $t('eschool.createForBranch') }}
            <span class="text-danger">*</span>
          </h2>
          <div class="px-2">
            <div class="row">
              <div
                v-for="(branch, index) in branch_lists"
                :key="index"
                class="col-12 col-sm-6 col-md-4 col-lg-12 mb-2"
              >
                <ts-checkbox
                  :value="branch.branch_id"
                  v-model="model.branch_id_list"
                >
                  {{ branch.branch_name_en }}
                </ts-checkbox>
              </div>
            </div>
            <div
              style="color:#cc4946;margin:4px 0 0"
              v-if="errors.has('branch_id_list')"
            >
              {{ errors.first('branch_id_list') }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <h2 class="ts-capitalize ts-font-semibold ts-underline mb-2">
            {{ $t('eschool.receiver') }} <span class="text-danger">*</span>
          </h2>
          <div class="px-2">
            <div class="d-flex flex-wrap">
              <ts-checkbox v-model="model.is_staff_event" class="mr-3 mb-2">
                {{ $t('eschool.staff') }}
              </ts-checkbox>
              <ts-checkbox v-model="model.is_parent_event" class="mr-3 mb-2">
                {{ $t('eschool.parent') }}
              </ts-checkbox>
              <ts-checkbox v-model="model.is_student_event" class="mr-3 mb-2">
                {{ $t('eschool.student') }}
              </ts-checkbox>
            </div>
          </div>
          <div
            style="color:#cc4946;margin:4px 0 0"
            v-if="errors.has('receiver')"
          >
            {{ errors.first('receiver') }}
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-end align-items-center mt-3 pt-2">
          <ts-button @click="cancel()" v-if="editing == true" class="mr-2 mb-2">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            class="mb-2"
            color="primary"
            :disabled="saving"
            :waiting="saving"
            @click="update"
            v-if="editing == true"
          >
            {{ $t('update') }}
          </ts-button>
          <ts-button
            class="mb-2"
            color="primary"
            :disabled="saving"
            :waiting="saving"
            @click="save"
            v-else
          >
            {{ $t('save') }}
          </ts-button>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'event-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        branch_id_list: [],
        event_name: '',
        event_start_date: moment().format('DD-MM-YYYY'),
        event_end_date: moment().format('DD-MM-YYYY'),
        event_criteria: '',
        is_staff_event: false,
        is_parent_event: false,
        is_student_event: false
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      loading: false,
      branch_lists: []
    }
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'event' })
    },

    // Returns an object of errors (empty if the form is valid)
    validateForm(checkBranch = false) {
      const errs = {}
      const fmt = 'DD-MM-YYYY'

      if (!this.model.event_name || !this.model.event_name.trim()) {
        errs.event_name = ['The event name field is required.']
      }

      const start = moment(this.model.event_start_date, fmt, true)
      const end = moment(this.model.event_end_date, fmt, true)

      if (!this.model.event_start_date || !start.isValid()) {
        errs.event_start_date = ['The event start date field is required.']
      }
      if (!this.model.event_end_date || !end.isValid()) {
        errs.event_end_date = ['The event end date field is required.']
      }
      if (start.isValid() && end.isValid() && start.isAfter(end)) {
        errs.event_start_date = [
          'The event start date must be a date before or equal to event end date.'
        ]
        errs.event_end_date = [
          'The event end date must be a date after or equal to event start date.'
        ]
      }

      if (
        !this.model.is_staff_event &&
        !this.model.is_parent_event &&
        !this.model.is_student_event
      ) {
        errs.receiver = [
          'Please select at least one receiver (Staff, Parent or Student).'
        ]
      }

      if (
        checkBranch &&
        (!this.model.branch_id_list || this.model.branch_id_list.length === 0)
      ) {
        errs.branch_id_list = ['Please select at least one Branch.']
      }

      return errs
    },

    async save() {
      this.errors = new Errors()

      const errs = this.validateForm(true)
      if (Object.keys(errs).length) {
        this.errors = new Errors(errs)
        this.$toasted.error('The given data was invalid.')
        return
      }

      this.saving = true
      try {
        let response = await this.$store.dispatch('event/create', this.model)
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.errors = new Errors()

      const errs = this.validateForm(false)
      if (Object.keys(errs).length) {
        this.errors = new Errors(errs)
        this.$toasted.error('The given data was invalid.')
        return
      }

      this.saving = true
      try {
        let response = await this.$store.dispatch('event/update', this.model)
        this.$toasted.success(response.message)
        this.$router.push({ name: 'event' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async setEdit() {
      if (this.edit === null || this.edit === undefined) {
        this.loading = true
        let response = await this.$store.dispatch('event/getBranch')
        this.branch_lists = response.data
        this.loading = false
        return
      }
      this.errors = new Errors()
      this.model = Object.assign({}, { branch_id_list: [] }, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.event_name = ''
      this.model.event_start_date = moment().format('DD-MM-YYYY')
      this.model.event_end_date = moment().format('DD-MM-YYYY')
      this.model.event_criteria = ''
      this.model.is_staff_event = false
      this.model.is_parent_event = false
      this.model.is_student_event = false
      this.model.branch_id_list = []
    }
  },
  watch: {
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
